import Title from './title'

export default function Members({ studio }) {
  const t = useI18n()
  if (!studio.showableStylists?.length) return
  return (
    <div className='px-5'>
      <div className='flex space-x-1'>
        <Title>{ t('page:studioId.stylist') }</Title>
      </div>

      <div className='flex flex-wrap'>
        { studio.showableStylists.map(({ user }) => (
          <div
            key={ user.avatar }
            className='py-2 px-2 w-1/4'
          >
            <C.Link blank noUnderline href={ h.path.stylist({ id: user.id }) }>
              <div className='p-[2px] border-2 rounded-full border-blue-200'>
                <C.Image
                  src={ user.avatar }
                  className='pt-[100%] rounded-full'
                />
              </div>
              <div className='line-clamp-1 text-xs text-center font-medium pt-[0.4rem] sm:text-sm'>
                { user.name }
              </div>
            </C.Link>
          </div>
        )) }
      </div>
    </div>
  )
}
